import { gql } from 'apollo-angular';

export const GET_CROSSES_DISTRIBUTOR = gql`
  query getCrosses(
    $searchValue: String!
    $categoryId: Long!
    $variant: String
  ) {
    optimizedPurchasedProducts(
      variant: $variant
      searchCriteria: {
        limit: 50
        searchValue: $searchValue
        boostCriteria: { fieldName: "categoryId", fieldValue: $categoryId }
      }
    ) {
      id
      brandName
      catalogNumber
      manufacturerCatalogNumber
      description
      status
      packageString
      productSource
      categories {
        id
        name
        parents {
          id
          name
        }
      }
      manufacturer {
        id
        name
      }
      parentManufacturer {
        id
        name
      }
      distributor {
        id
        name
      }
      parentDistributor {
        id
        name
      }
    }
  }
`;

export default GET_CROSSES_DISTRIBUTOR;
